// ---------------------------------------------------------

import Component from './component';
import transform from './transformer';

// ---------------------------------------------------------

const FeaturedContent = (props) => <Component {...transform(props)} />;

export default FeaturedContent;

// ---------------------------------------------------------

export { Component as component, transform as transformer };
